import { Component, computed, inject } from '@angular/core';
import {
  BasketService,
  SinglePlanPromoPriceComponent,
  TitlePriceVariant,
} from '@basket';
import { CatalogueService } from '@catalogue';
import {
  BenefitsListCoveredItemsComponent,
  IconComponent,
  TermsAndConditionsPanelComponent,
} from '@components';
import { CustomerService } from '@customer';
import {
  CoverDetailsService,
  translation as dataAccessTranslation,
} from '@data-access';
import { LabelledCheckboxComponent } from '@forms';
import {
  CurrencyFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
  TranslateService,
} from '@i18n';
import { isAfter, subMonths } from 'date-fns';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'app-upsell-checkbox',
  imports: [
    BenefitsListCoveredItemsComponent,
    CurrencyFormatPipe,
    IconComponent,
    LabelledCheckboxComponent,
    SinglePlanPromoPriceComponent,
    TermsAndConditionsPanelComponent,
    TranslatePipe,
  ],
  providers: [
    provideTranslationDictionaryMapping(translation),
    provideTranslationDictionaryMapping(dataAccessTranslation),
  ],
  templateUrl: './upsell-checkbox.component.html',
  styleUrl: './upsell-checkbox.component.scss',
})
export class UpsellCheckboxComponent {
  private readonly catalogueService = inject(CatalogueService);
  private readonly coverDetailsService = inject(CoverDetailsService);
  private readonly translateService = inject(TranslateService);
  readonly basketService = inject(BasketService);
  readonly customerService = inject(CustomerService);

  protected readonly TitlePriceVariant = TitlePriceVariant;
  readonly selectedQuotePaymentOption = computed(() =>
    this.basketService.basketItemQuoteDetailsPaymentOption(),
  );

  readonly hasPromo = () => this.basketService.basketItemQuoteHasPromo();
  readonly hasFreeMonths = () =>
    this.basketService.basketItemQuoteHasFreeMonths();
  readonly isOneOffPayment = () =>
    this.basketService.basketItemQuoteIsOneOffPayment();

  readonly coveredItems = this.coverDetailsService.getCoveredItems;

  readonly notCoveredItems: string[] = [
    this.translateService.translate(
      'COVER_DETAILS_EXCLUSION_DELIBERATE_DAMAGE',
    ),
    this.translateService.translate(
      'COVER_DETAILS_EXCLUSION_INSTALLATION_COSTS',
    ),
  ];

  readonly applianceInGuarantee = computed(() =>
    isAfter(
      this.catalogueService.selectedAppliancePurchaseDate(),
      subMonths(new Date(), 3),
    ),
  );

  onUpsellChecked(checked: boolean) {
    this.customerService.setCustomerSelectedToPurchasePlan(checked);
  }
}
